export default __webpack_public_path__ + "static/media/menu-settings_darkGray3.b2f6d1d4.svg";